import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["suggestions", "classes", "DownshiftProps", "renderInputField", "creatable"],
  _excluded2 = ["selectedItem"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
//
/*
 * Taken from the downshift example located at https://material-ui.com/demos/autocomplete/
 * Multiple selection not supported yet
 */
//@ts-nocheck
import { withStyles } from "components/mui";
import Downshift from "downshift";
import * as React from "react";
import DefaultAutocompleteInputField from "./DefaultAutocompleteInputField";
import DefaultSuggestionsPopper from "./DefaultSuggestionsPopper";
import omit from "core/Utils/omit";
import pick from "core/Utils/pick";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HTML_INPUT_ATTRIBUTES = ["aria-autocomplete", "aria-activedescendant", "aria-controls", "aria-labelledby"];
var AutoCompleteInput = /*#__PURE__*/function (_React$Component) {
  function AutoCompleteInput() {
    var _context;
    var _this;
    _classCallCheck(this, AutoCompleteInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AutoCompleteInput, _concatInstanceProperty(_context = []).call(_context, args));
    _defineProperty(_this, "inputNode", null);
    return _this;
  }
  _inherits(AutoCompleteInput, _React$Component);
  return _createClass(AutoCompleteInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        suggestions = _this$props.suggestions,
        classes = _this$props.classes,
        _this$props$Downshift = _this$props.DownshiftProps,
        DownshiftProps = _this$props$Downshift === void 0 ? {} : _this$props$Downshift,
        _this$props$renderInp = _this$props.renderInputField,
        renderInputField = _this$props$renderInp === void 0 ? defaultInputFieldRenderer : _this$props$renderInp,
        creatable = _this$props.creatable,
        muiFieldProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/_jsx("div", {
        className: classes.root,
        children: /*#__PURE__*/_jsx(Downshift, _objectSpread(_objectSpread({}, DownshiftProps), {}, {
          children: function children(_ref) {
            var getItemProps = _ref.getItemProps,
              getInputProps = _ref.getInputProps,
              getToggleButtonProps = _ref.getToggleButtonProps,
              getLabelProps = _ref.getLabelProps,
              clearSelection = _ref.clearSelection,
              getMenuProps = _ref.getMenuProps,
              isOpen = _ref.isOpen,
              itemToString = _ref.itemToString,
              toggleMenu = _ref.toggleMenu,
              selectedItem = _ref.selectedItem,
              inputValue = _ref.inputValue;
            var inputProps = getInputProps({
              onChange: function onChange(e) {
                if (e.target.value === "") {
                  clearSelection();
                }
              },
              onClick: function onClick() {
                if (!isOpen && !muiFieldProps.disabled) {
                  toggleMenu();
                }
              }
            });
            var inputAttributes = pick(inputProps, HTML_INPUT_ATTRIBUTES);
            inputProps.value = inputProps.value || "";
            return /*#__PURE__*/_jsxs("div", {
              className: classes.container,
              children: [renderInputField(_objectSpread({
                InputLabelProps: getLabelProps(),
                InputProps: _objectSpread({
                  inputRef: function inputRef(node) {
                    _this2.inputNode = node;
                  }
                }, omit(inputProps, HTML_INPUT_ATTRIBUTES)),
                inputProps: inputAttributes,
                selectedItem: selectedItem
              }, muiFieldProps)), /*#__PURE__*/_jsx(DefaultSuggestionsPopper, {
                open: isOpen,
                anchorEl: _this2.inputNode,
                getMenuProps: getMenuProps,
                getToggleButtonProps: getToggleButtonProps,
                suggestions: suggestions,
                itemToString: itemToString,
                getItemProps: getItemProps,
                toggleMenu: toggleMenu,
                creatable: creatable,
                inputValue: inputValue
              })]
            });
          }
        }))
      });
    }
  }]);
}(React.Component); // selectedItem not needed in the default renderer to its destructured out
function defaultInputFieldRenderer(_ref2) {
  var selectedItem = _ref2.selectedItem,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(DefaultAutocompleteInputField, _objectSpread({}, props));
}
export var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1
    },
    container: {
      flexGrow: 1,
      position: "relative"
    }
  };
};
export default withStyles(styles)(AutoCompleteInput);